import { v4 as uuidv4 } from "uuid";
import resumeContent from './ResumeDummyContent';
import * as api from "../../api/index.js";

export const templates = [
  {
    id: uuidv4(),
    name: "template1",
    header: ["personal_details"],
    panels: [
      {
        items: ["experiences", "educations"],
        flex: 50,
        rightPad: true,
      },
      {
        items: ["skills", "projects", "certificates"],
        flex: 50,
        rightPad: false,
      },
    ],
    primaryColor: "#000", //438961
    secondaryColor: "#22ff22",
    sections: {
      personal_details: {
        theme: "theme1"
      }
    },
    pageHeaderDivider: true,
    underlineSectionHeader: false,
  },
  {
    id: uuidv4(),
    name: "template2",
    header: ["personal_details"],
    panels: [
      {
        items: ["experiences", "educations"],
        flex: 50,
        rightPad: true,
      },
      {
        items: ["skills", "projects", "certificates"],
        flex: 50,
        rightPad: false,
      },
    ],
    primaryColor: "#01579b",
    secondaryColor: "#22ff22",
    sections: {
      personal_details: {
        theme: "theme2"
      }
    },
    underlineSectionHeader: true,
    pageHeaderDivider: false,
  },
  {
    id: uuidv4(),
    name: "template3",
    header: ["personal_details"],
    panels: [
      {
        items: ["experiences", "educations", "skills", "projects", "certificates"],
        flex: 100,
        rightPad: false,
      },
    ],
    primaryColor: "#000", //438961
    secondaryColor: "#22ff22",
    sections: {
      personal_details: {
        theme: "theme3"
      }
    },
    underlineSectionHeader: true,
  },
  {
    id: uuidv4(),
    name: "template4",
    header: ["personal_details"],
    panels: [
      {
        items: ["summary", "skills", "achievements", "languages", "interests"],
        flex: 40,
        rightPad: true,
      },
      {
        items: ["experiences", "projects", "educations"],
        flex: 60,
        rightPad: false,
      },
    ],
    primaryColor: "#000", //438961
    secondaryColor: "#22ff22",
    sections: {
      personal_details: {
        theme: "theme1"
      },
      skills: {
        theme: "outline"
      }
    },
    pageHeaderDivider: true,
    underlineSectionHeader: false,
  },
  {
    id: uuidv4(),
    name: "template5",
    header: ["personal_details"],
    panels: [
      {
        items: ["experiences", "educations"],
        flex: 50,
        rightPad: true,
      },
      {
        items: ["skills", "projects", "certificates"],
        flex: 50,
        rightPad: false,
      },
    ],
    primaryColor: "#000000",
    secondaryColor: "#22ff22",
    sections: {
      personal_details: {
        theme: "theme2"
      },
      skills: {
        theme: "outline"
      }
    },
    underlineSectionHeader: true,
    pageHeaderDivider: false,
  },
  {
    id: uuidv4(),
    name: "template6",
    header: ["personal_details"],
    panels: [
      {
        items: ["experiences", "educations", "skills", "projects"],
        flex: 100,
        rightPad: false,
      },
    ],
    primaryColor: "#000", //438961
    secondaryColor: "#22ff22",
    sections: {
      skills: {
        theme: "outline"
      }
    },
    pageHeaderDivider: true,
  },
];

export const colours = ['#e57373', '#ef5350', '#f44336', '#e53935', '#d32f2f', '#c62828', '#b71c1c', '#ff8a80', '#ff5252', '#ff1744', '#d50000', '#f06292', '#ec407a', '#e91e63', '#d81b60', '#c2185b', '#ad1457', '#880e4f', '#ff80ab', '#ff4081', '#f50057', '#c51162', '#ba68c8', '#ab47bc', '#9c27b0', '#8e24aa', '#7b1fa2', '#6a1b9a', '#4a148c', '#ea80fc', '#e040fb', '#d500f9', '#aa00ff', '#9575cd', '#7e57c2', '#673ab7', '#5e35b1', '#512da8', '#4527a0', '#311b92', '#b388ff', '#7c4dff', '#651fff', '#6200ea', '#7986cb', '#5c6bc0', '#3f51b5', '#3949ab', '#303f9f', '#283593', '#1a237e', '#8c9eff', '#536dfe', '#3d5afe', '#304ffe', '#64b5f6', '#42a5f5', '#2196f3', '#1e88e5', '#1976d2', '#1565c0', '#0d47a1', '#82b1ff', '#448aff', '#2979ff', '#2962ff', '#4fc3f7', '#29b6f6', '#03a9f4', '#039be5', '#0288d1', '#0277bd', '#01579b', '#80d8ff', '#40c4ff', '#00b0ff', '#0091ea', '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f', '#006064', '#84ffff', '#18ffff', '#00e5ff', '#00b8d4', '#4db6ac', '#26a69a', '#009688', '#00897b', '#00796b', '#00695c', '#004d40', '#a7ffeb', '#64ffda', '#1de9b6', '#00bfa5', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c', '#2e7d32', '#1b5e20', '#b9f6ca', '#69f0ae', '#00e676', '#00c853', '#aed581', '#9ccc65', '#8bc34a', '#7cb342', '#689f38', '#558b2f', '#33691e', '#ccff90', '#b2ff59', '#76ff03', '#64dd17', '#dce775', '#d4e157', '#cddc39', '#c0ca33', '#afb42b', '#9e9d24', '#827717', '#f4ff81', '#eeff41', '#c6ff00', '#aeea00', '#fff176', '#ffee58', '#ffeb3b', '#fdd835', '#fbc02d', '#f9a825', '#f57f17', '#ffff8d', '#ffff00', '#ffea00', '#ffd600', '#ffd54f', '#ffca28', '#ffc107', '#ffb300', '#ffa000', '#ff8f00', '#ff6f00', '#ffe57f', '#ffd740', '#ffc400', '#ffab00', '#ffb74d', '#ffa726', '#ff9800', '#fb8c00', '#f57c00', '#ef6c00', '#e65100', '#ffd180', '#ffab40', '#ff9100', '#ff6d00', '#ff8a65', '#ff7043', '#ff5722', '#f4511e', '#e64a19', '#d84315', '#bf360c', '#ff9e80', '#ff6e40', '#ff3d00', '#dd2c00', '#a1887f', '#8d6e63', '#795548', '#6d4c41', '#5d4037', '#4e342e', '#3e2723', '#9e9e9e', '#616161', '#424242', '#212121', '#607d8b', '#b0bec5', '#90a4ae', '#78909c', '#607d8b', '#546e7a'];

export const fonts = [
  ['Roboto', 'sans-serif'],
  ['IBM Plex Sans', 'sans-serif'],
  ['Inconsolata', 'monospace'],
  ['Merriweather', 'serif'],
  ['Open Sans', 'sans-serif'],
  ['Raleway', 'sans-serif'],
  ['Ubuntu', 'sans-serif'],
]

export const sections = [
  'experiences',
  'skills',
  'projects',
  'educations',
  'summary',
  'achievements',
  'interests',
  'languages',
  'certificates',
]

export const emptyPersonalDetails = () => {
  return {
    name: "",
    title: "",
    pitch: "",
    email: "",
    phone: "",
    links: [
      {
        id: uuidv4(),
        text: "",
      },
      {
        id: uuidv4(),
        text: "",
      },
    ],
    page: 0,
  }
}

export const emptyExperience = () => {
  return {
    id: uuidv4(),
    position: "",
    company: "",
    description: "",
    period: "",
    points: [
      {
        id: uuidv4(),
        text: "",
      },
    ],
    page: 0,
  };
};

export const emptyEducation = () => {
  return {
    id: uuidv4(),
    course: "",
    institute: "",
    description: "",
    period: "",
    points: [
      {
        id: uuidv4(),
        text: "",
      },
    ],
    page: 0,
  };
};

export const emptyProject = () => {
  return {
    id: uuidv4(),
    title: "",
    period: "",
    description: "",
    points: [
      {
        id: uuidv4(),
        text: "",
      }
    ],
    page: 0,
  };
};

export const emptySkill = () => {
  return {
    id: uuidv4(),
    name: "",
    page: 0,
  };
};

export const emptyInterest = () => {
  return {
    id: uuidv4(),
    name: "",
    page: 0,
  };
};

export const emptyLanguage = () => {
  return {
    id: uuidv4(),
    name: "",
    page: 0,
  };
};

export const emptyAchievement = () => {
  return {
    id: uuidv4(),
    title: "",
    description: "",
    page: 0,
  };
};

export const emptyCertificate = () => {
  return {
    id: uuidv4(),
    title: "",
    description: "",
    period: "",
    page: 0,
  };
};

export const emptySummary = () => {
  return {
    id: uuidv4(),
    description: "",
    page: 0,
  };
};

export const fontSizeBase = {
  xxlarge: 35,
  xlarge: 18,
  large: 15,
  medium: 12,
  normal: 12,
  small: 10
}

export const pageState = () => {
  return {
    pageCount: 1
  };
}

export const getEmptySection = (section) => {
  switch (section) {
    case "experiences": {
      return emptyExperience();
    }
    case "educations": {
      return emptyEducation();
    }
    case "projects": {
      return emptyProject();
    }
    case "skills": {
      return emptySkill();
    }
    case "interests": {
      return emptyInterest();
    }
    case "languages": {
      return emptyLanguage();
    }
    case "achievements": {
      return emptyAchievement();
    }
    case "certificates": {
      return emptyCertificate();
    }
    case "summary": {
      return emptySummary();
    }
  }
}

export const initResumeState = () => {
  return {
    data: {
      personalDetails: emptyPersonalDetails(),
      experiences: {
        title: "experience",
        items: [emptyExperience()]
      },
      educations: {
        title: "education",
        items: [emptyEducation()]
      },
      projects: {
        title: "projects",
        items: [emptyProject()]
      },
      skills: {
        title: "skills",
        items: [emptySkill()]
      },
      interests: {
        title: "interests",
        items: [emptyInterest()]
      },
      languages: {
        title: "languages",
        items: [emptyLanguage()]
      },
      achievements: {
        title: "achievements",
        items: [emptyAchievement()]
      },
      certificates: {
        title: "certificates",
        items: [emptyCertificate()]
      },
      summary: {
        title: "summary",
        items: [emptySummary()]
      }
    },
    pageState: pageState(),
    unsavedChanges: false
  };
}

export const initResumeStateDummy = () => {
  return {
    data: resumeContent,
    pageState: pageState()
  };
}

export const initTemplateState = (templateId) => {
  let template = templates[0];
  if (templateId) {
    const selectedTemplate = templates.filter(t => t.name === templateId);
    if (selectedTemplate && selectedTemplate.length > 0) {
      template = selectedTemplate[0];
    }
  }
  template.fontSize = fontSizeBase;
  template.font = ['Roboto', 'sans-serif'];
  return template;
}

export const processResume = (resume) => {
  // const resumeInitialState = {
  //   data: resume.data,
  //   pageState: pageState()
  // };

  const resumeInitialState = initResumeState();
  resumeInitialState.data = Object.assign(resumeInitialState.data, resume.data);
  console.log('process resume');
  
  for (let section of Object.keys(resumeInitialState.data)) {
    if (resumeInitialState.data[section].hasOwnProperty("items")) {
      if (resumeInitialState.data[section].items.length === 0) {
        resumeInitialState.data[section].items = [getEmptySection(section)];
      }
      for (let i = 0; i < resumeInitialState.data[section].items.length; i++) {
        resumeInitialState.data[section].items[i].page = 0;
      }
    }
  }

  const templateInitialState = resume.template;

  return {
    id: resume._id,
    resumeState: resumeInitialState,
    templateState: templateInitialState
  }
}

export const loadData = async (resumeId, authtoken) => {
  const response = await api.loadResume(resumeId, authtoken);
  if (response.status === 200) {
    return processResume(response.data);
  }
  return null;
};